import SignupPage from 'views/Auth/SignupPage'
export default SignupPage
